import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { fmtFechaHora } from '../utils/fecha'
import { marketingApi } from '../api/marketing'
import { useAutoRefresh } from '../hooks/useAutoRefresh'
import Boton from '../components/Boton'
import Paginador from '../components/Paginador'

const ESTADO_CHIP = {
  borrador:   { label: 'Borrador',   bg: '#f1f5f9', color: '#475569' },
  programada: { label: 'Programada', bg: '#eff6ff', color: '#1d4ed8' },
  enviando:   { label: 'Enviando…',  bg: '#fef9c3', color: '#a16207' },
  pausada:    { label: 'Pausada',    bg: '#fff7ed', color: '#c2410c' },
  enviada:    { label: '✓ Enviada',  bg: '#dcfce7', color: '#166534' },
  cancelada:  { label: 'Cancelada',  bg: '#fee2e2', color: '#991b1b' },
}

export default function MktCampanasPage() {
  const navigate = useNavigate()
  const [data, setData] = useState(null)
  const [q, setQ] = useState('')
  const [estado, setEstado] = useState('')
  const [page, setPage] = useState(1)

  const cargar = useCallback(async ({ silent } = {}) => {
    const res = await marketingApi.campanas({ q: q || undefined, estado: estado || undefined, page })
    setData(res.data)
  }, [q, estado, page])

  useEffect(() => { cargar() }, [cargar])
  useAutoRefresh(cargar, 30000)

  const rows = data?.data || []

  return (
    <div>
      <div style={st.head}>
        <h2 style={st.title}>Campañas de email</h2>
        <Boton variante="primary" onClick={() => navigate('/marketing/campanas/nueva')}>+ Nueva campaña</Boton>
      </div>

      <div style={st.filtros}>
        <input style={st.buscador} placeholder="Buscar por nombre…" value={q}
          onChange={e => { setQ(e.target.value); setPage(1) }} />
        <select style={st.select} value={estado} onChange={e => { setEstado(e.target.value); setPage(1) }}>
          <option value="">Todos los estados</option>
          {Object.entries(ESTADO_CHIP).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      <div style={st.tableWrap}>
        <table style={st.table}>
          <thead>
            <tr>
              {['Campaña', 'Lista', 'Estado', 'Destinatarios', 'Enviados', 'Programada', ''].map(h =>
                <th key={h} style={st.th}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map(c => {
              const chip = ESTADO_CHIP[c.estado] || ESTADO_CHIP.borrador
              return (
                <tr key={c.id} style={st.tr} onClick={() => navigate(`/marketing/campanas/${c.id}`)}>
                  <td style={st.td}><strong>{c.nombre}</strong><div style={st.sub}>{c.asunto}</div></td>
                  <td style={st.td}>{c.lista?.nombre || '—'}</td>
                  <td style={st.td}><span style={{ ...st.chip, background: chip.bg, color: chip.color }}>{chip.label}</span></td>
                  <td style={st.td}>{c.total_destinatarios || '—'}</td>
                  <td style={st.td}>{c.total_enviados || '—'}</td>
                  <td style={st.td}>{c.programada_at ? fmtFechaHora(c.programada_at) : '—'}</td>
                  <td style={st.td}>›</td>
                </tr>
              )
            })}
            {rows.length === 0 && (
              <tr><td colSpan={7} style={{ ...st.td, textAlign: 'center', color: '#94a3b8', padding: 32 }}>
                Sin campañas todavía. Creá la primera con "+ Nueva campaña".
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {data && <Paginador pagina={data.current_page} totalPaginas={data.last_page} onCambiar={setPage} />}
    </div>
  )
}

const st = {
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  title: { margin: 0, fontSize: '1.4rem', color: '#0f172a' },
  filtros: { display: 'flex', gap: 10, marginBottom: 12 },
  buscador: { flex: 1, maxWidth: 360, padding: '0.55rem 0.8rem', border: '1px solid #d1d5db', borderRadius: 8 },
  select: { padding: '0.55rem 0.8rem', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff' },
  tableWrap: { background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', padding: '10px 14px', fontSize: '0.72rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' },
  tr: { cursor: 'pointer', borderBottom: '1px solid #f1f5f9' },
  td: { padding: '12px 14px', fontSize: '0.9rem', color: '#1e293b' },
  sub: { fontSize: '0.78rem', color: '#94a3b8', marginTop: 2 },
  chip: { padding: '3px 10px', borderRadius: 10, fontSize: '0.75rem', fontWeight: 700 },
  pager: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 14, marginTop: 14 },
  pagerBtn: { padding: '0.4rem 0.9rem', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer' },
}
